module.exports = __webpack_public_path__ + "img/arrowService.4c3ee359.svg";